module.exports = __webpack_public_path__ + "static/media/Warning.7d163f0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkout/Warning/Warning.svg
// module id = 1784
// module chunks = 0